var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.47,127.1c48.1,5.38,69.21-36.32,116.88-30.86,42.54,4.87,71.88,35.18,61.95,76-8.82,36.24-50.81,47.61-65.74,81.56-15.83,36-28.1,74.79-75.9,87.32-93.85,24.6-139.44-90.88-145.83-157.21-2.45-25.46-6.73-86.33,26.51-94.21C191.79,81.76,211,123.8,240.47,127.1Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.47,127.1c48.1,5.38,69.21-36.32,116.88-30.86,42.54,4.87,71.88,35.18,61.95,76-8.82,36.24-50.81,47.61-65.74,81.56-15.83,36-28.1,74.79-75.9,87.32-93.85,24.6-139.44-90.88-145.83-157.21-2.45-25.46-6.73-86.33,26.51-94.21C191.79,81.76,211,123.8,240.47,127.1Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-11",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-no-data--inject-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.78,
    y: 202.37,
    width: 1,
    height: 18.49,
    transform: "translate(-14.93 8.04) rotate(-4.12)",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.38,
    y: 230.35,
    width: 1,
    height: 6.96,
    transform: "translate(-16.53 8.21) rotate(-4.12)",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.71,315.16H123.55a9.65,9.65,0,0,1-9.44-8.81L103.59,160.22a8.1,8.1,0,0,1,8.17-8.8H325.92a9.65,9.65,0,0,1,9.44,8.8l10.52,146.13A8.11,8.11,0,0,1,337.71,315.16Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35A8.1,8.1,0,0,1,338.53,315.16Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,315.16H124.37a9.65,9.65,0,0,1-9.44-8.81L104.41,160.22a8.1,8.1,0,0,1,8.17-8.8H326.74a9.65,9.65,0,0,1,9.44,8.8L346.7,306.35A8.1,8.1,0,0,1,338.53,315.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.06,155.82H112.9l-.72,0c-5.47.45-4.35,8.78,1.17,8.78H327.87c5.53,0,5.45-8.33-.09-8.78Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.48,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2A2.2,2.2,0,0,1,118.48,160.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,160.22a1.85,1.85,0,0,1-1.88,2,2.2,2.2,0,0,1-2.16-2,1.85,1.85,0,0,1,1.87-2A2.2,2.2,0,0,1,125.35,160.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,160.22a1.85,1.85,0,0,1-1.87,2,2.19,2.19,0,0,1-2.16-2,1.84,1.84,0,0,1,1.87-2A2.2,2.2,0,0,1,132.21,160.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.85,300.58H128a3.49,3.49,0,0,1-3.42-3.2l-8.65-120.17a2.92,2.92,0,0,1,3-3.19h204.9a3.48,3.48,0,0,1,3.42,3.19l8.66,120.17A2.94,2.94,0,0,1,332.85,300.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.53 254.8 243.19 208.48 233.09 202.4 205.28 202.4 209.06 254.8 246.53 254.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,255.28H209.06a.48.48,0,0,1-.49-.45l-3.77-52.4a.47.47,0,0,1,.13-.36.48.48,0,0,1,.35-.16h27.81a.55.55,0,0,1,.25.07l10.1,6.08a.48.48,0,0,1,.24.38L247,254.76a.46.46,0,0,1-.13.37A.47.47,0,0,1,246.53,255.28Zm-37-1H246l-3.28-45.55L233,202.88H205.8Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.19 208.48 233.09 202.4 236.8 210.46 243.19 208.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,210.94a.49.49,0,0,1-.44-.28l-3.71-8.06a.5.5,0,0,1,.11-.57.5.5,0,0,1,.58-.05l10.1,6.08a.5.5,0,0,1,.24.48.49.49,0,0,1-.34.4l-6.4,2Zm-2.61-7.32,2.87,6.25,5-1.53Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,226a2,2,0,0,1-2,2.11,2.31,2.31,0,0,1-2.26-2.11,1.94,1.94,0,0,1,2-2.12A2.32,2.32,0,0,1,221,226Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,226a1.94,1.94,0,0,1-2,2.11,2.32,2.32,0,0,1-2.27-2.11,2,2,0,0,1,2-2.12A2.31,2.31,0,0,1,234.7,226Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,239.74a.49.49,0,0,1-.48-.45c-.25-3.41-5.59-6.18-11.9-6.18-4.19,0-7.95,1.25-9.81,3.25a3.74,3.74,0,0,0-1.14,2.86.49.49,0,0,1-1,.07,4.76,4.76,0,0,1,1.4-3.59c2-2.19,6.07-3.56,10.52-3.56,6.93,0,12.58,3.11,12.86,7.08a.48.48,0,0,1-.45.51Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17,221.72a.51.51,0,0,1-.33-.13.49.49,0,0,1,0-.69l2.13-2.29a.49.49,0,0,1,.68,0,.48.48,0,0,1,0,.68l-2.13,2.29A.48.48,0,0,1,213.17,221.72Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.58,221.72a.55.55,0,0,1-.33-.13l-2.45-2.29a.48.48,0,0,1,0-.69.49.49,0,0,1,.68,0l2.45,2.29a.48.48,0,0,1,0,.68A.52.52,0,0,1,237.58,221.72Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.26,265.15h2.26l3.26,4.34-.31-4.34h2.28l.56,7.84H208l-3.24-4.31.31,4.31h-2.28Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,269.07a3.8,3.8,0,0,1,.86-3,3.76,3.76,0,0,1,2.9-1.07,4.38,4.38,0,0,1,3.09,1.05,4.32,4.32,0,0,1,1.27,2.94,4.77,4.77,0,0,1-.3,2.25,3,3,0,0,1-1.24,1.37,4.16,4.16,0,0,1-2.14.49,5.25,5.25,0,0,1-2.23-.42,3.62,3.62,0,0,1-1.5-1.34A4.66,4.66,0,0,1,211.33,269.07Zm2.43,0a2.73,2.73,0,0,0,.56,1.7,1.59,1.59,0,0,0,1.24.52,1.38,1.38,0,0,0,1.17-.51A2.75,2.75,0,0,0,217,269a2.57,2.57,0,0,0-.56-1.62,1.64,1.64,0,0,0-1.25-.51,1.38,1.38,0,0,0-1.14.52A2.53,2.53,0,0,0,213.76,269.09Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.15,265.15h3.6a4.51,4.51,0,0,1,1.74.29,3.06,3.06,0,0,1,1.14.83,3.76,3.76,0,0,1,.71,1.25,6.3,6.3,0,0,1,.3,1.52,5.08,5.08,0,0,1-.15,1.95,2.8,2.8,0,0,1-.71,1.16,2.3,2.3,0,0,1-1,.62,5.6,5.6,0,0,1-1.43.22h-3.59Zm2.55,1.78.31,4.28h.59a2.45,2.45,0,0,0,1.07-.17,1,1,0,0,0,.46-.59,3.54,3.54,0,0,0,.08-1.36,2.72,2.72,0,0,0-.53-1.7,1.81,1.81,0,0,0-1.38-.46Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,271.69H234.7l-.29,1.3h-2.47l2.38-7.84H237l3.51,7.84h-2.54Zm-.63-1.69-1.06-2.82L235.1,270Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.37,265.15h7.36l.14,1.94H244.4l.42,5.9H242.4l-.42-5.9h-2.47Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,271.69h-2.75l-.29,1.3h-2.47l2.38-7.84h2.64l3.5,7.84h-2.53Zm-.63-1.69-1.07-2.82L250,270Z",
    style: {
      fill: "#3B5EEB"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.69,173.08c.89-.45,2-1,2.94-1.57s2-1.12,3-1.72c1.95-1.21,3.93-2.4,5.8-3.72a76.94,76.94,0,0,0,10.52-8.66c.41-.38.77-.8,1.16-1.21l.57-.61.28-.3.14-.16s0,0,0,0l0,0c-.14.27,0,.19,0-.07a5.28,5.28,0,0,0,.15-1.09,30.6,30.6,0,0,0-.73-6.32c-.89-4.48-2.24-9.1-3.57-13.62l3.88-1.7a81.31,81.31,0,0,1,6.11,13.6,31.67,31.67,0,0,1,1.72,7.89,12,12,0,0,1-.08,2.51,7.71,7.71,0,0,1-1.22,3.29l-.17.23-.13.16-.15.19-.31.38-.62.75c-.41.49-.81,1-1.25,1.47A71.85,71.85,0,0,1,370.35,173c-2,1.48-4.12,2.9-6.29,4.19-1.07.65-2.16,1.27-3.27,1.88s-2.19,1.17-3.47,1.77Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79,408.18a10.27,10.27,0,0,0,2.22-.3.22.22,0,0,0,.15-.16.21.21,0,0,0-.09-.2c-.29-.19-2.83-1.83-3.81-1.39a.68.68,0,0,0-.39.56,1.13,1.13,0,0,0,.33,1.05A2.35,2.35,0,0,0,344.79,408.18Zm1.65-.58c-1.45.29-2.55.24-3-.15a.77.77,0,0,1-.2-.71.3.3,0,0,1,.17-.25C343.94,406.26,345.41,407,346.44,407.6Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,407.88l.1,0a.21.21,0,0,0,.1-.17c0-.11,0-2.52-.92-3.32a1,1,0,0,0-.84-.27.69.69,0,0,0-.67.55c-.19,1,1.33,2.75,2.13,3.21A.18.18,0,0,0,347,407.88Zm-1.43-3.39a.66.66,0,0,1,.44.17,4.53,4.53,0,0,1,.78,2.64c-.8-.64-1.75-2-1.63-2.57,0-.09.07-.21.32-.24Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.22,148.07c-1,5-3,15,.45,18.35,0,0-1.36,5-10.59,5-10.16,0-4.85-5-4.85-5,5.54-1.32,5.39-5.43,4.43-9.3Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.28,168.42c-1.59.22-.23-3.91.41-4.34,1.5-1,20.86-2.39,20.73,0-.08,1-.56,3-1.4,3.66S343.2,166.34,329.28,168.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,167c-1.27.43-1.15-3.73-.72-4.23,1-1.16,16.67-5.18,17.13-2.91.18,1,.27,3-.27,3.71S343.44,163.11,332.44,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.61,139.11a.4.4,0,0,1-.33-.15,3.18,3.18,0,0,0-2.59-1.23.39.39,0,0,1-.44-.35.4.4,0,0,1,.35-.43,3.91,3.91,0,0,1,3.29,1.51.4.4,0,0,1-.05.56A.5.5,0,0,1,326.61,139.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.67,144a17.91,17.91,0,0,1-2,4.53,2.9,2.9,0,0,0,2.44.21Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,142.79c.07.67-.24,1.25-.68,1.29s-.85-.46-.91-1.14.24-1.25.67-1.29S325.09,142.11,325.16,142.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,141.67l-1.66-.31S323.73,142.54,324.44,141.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.7 407.69 348.32 407.69 348.98 388.29 357.36 388.29 356.7 407.69",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.66,406.72h9.41a.66.66,0,0,1,.67.57l1.07,7.44a1.34,1.34,0,0,1-1.34,1.49c-3.28-.05-4.86-.25-9-.25-2.55,0-6.27.27-9.78.27s-3.71-3.48-2.24-3.79c6.56-1.42,7.6-3.36,9.81-5.22A2.21,2.21,0,0,1,347.66,406.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "357.36 388.29 348.98 388.29 348.64 398.29 357.02 398.29 357.36 388.29"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.37,178a162.48,162.48,0,0,1-15.05-6.75,91.24,91.24,0,0,1-14.4-8.77,34.31,34.31,0,0,1-3.42-3.07c-.28-.3-.56-.58-.83-.93a11.32,11.32,0,0,1-.88-1.13,7.9,7.9,0,0,1-1.34-3.61,8.22,8.22,0,0,1,.49-3.62,10.64,10.64,0,0,1,1.41-2.6,18.13,18.13,0,0,1,3.39-3.52,42,42,0,0,1,7.3-4.67c1.24-.66,2.5-1.25,3.78-1.8s2.54-1.07,3.91-1.54l1.77,3.85c-4.36,2.75-8.88,5.78-12.2,9.16a13.86,13.86,0,0,0-1.95,2.49c-.48.79-.47,1.38-.39,1.33s0,0,.14.1l.4.43c.15.18.36.36.55.55a25.62,25.62,0,0,0,2.69,2.16,62.92,62.92,0,0,0,6.44,4c2.25,1.26,4.57,2.45,6.93,3.59,4.72,2.26,9.6,4.43,14.39,6.41Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,137.15l1.38-3L307.06,132s-2,5.91.37,8.63h0A6.05,6.05,0,0,0,312,137.15Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.35 127.66 308.32 126.2 307.06 131.96 313.35 134.15 313.35 127.66",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,134.44l.73-7L372.6,129s-.1,6.58,3.33,7.62Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.96 122.51 371.73 124.48 372.6 128.95 379.08 127.42 375.96 122.51",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,138.25c.31,8.31.61,11.82-3.14,16.47-5.65,7-15.92,5.55-18.7-2.5-2.5-7.24-2.58-19.61,5.18-23.69A11.34,11.34,0,0,1,347.54,138.25Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,154.71c8.16-3.53,13.52-11,11.26-22.58-2.17-11.11-9.67-12.21-12.77-9.91s-10.83-1.13-15.47,2.77c-8,6.77-.44,14,3.52,18.37C332.82,148.22,335.92,158.16,343.92,154.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.53,130.14a8.29,8.29,0,1,0,1.83-11.92A8.53,8.53,0,0,0,340.53,130.14Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.65,123c-1.17-6.7,5.16-11.86,13.64-9.37s4,10,2.25,16,2.83,11.72,4.73,7.15-1.3-6-1.3-6,9,2.33.64,12.48-15.93-1.06-13.88-7.67C350.39,130.28,343.76,129.33,342.65,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18,125.53c-3.87-2-10.42-3.65-14.15,2.63-1.76,3-1.08,7-1.08,7l11.39.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.61,133.18h0a.26.26,0,0,1-.24-.27c0-.17.29-4.19,2.72-6.71,5.87-6.1,12.75-1,14.71.65a.25.25,0,0,1-.32.38c-1.89-1.62-8.47-6.47-14-.69-2.3,2.39-2.58,6.36-2.58,6.4A.25.25,0,0,1,317.61,133.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,143a6.89,6.89,0,0,1-1.65,4.28c-1.38,1.62-3,.82-3.33-1-.33-1.61,0-4.4,1.74-5.37S331.87,141.18,331.85,143Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,219.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,219.12s.54,58.15,5.58,90.55c4.08,26.17,11.61,86.69,11.61,86.69h11.43s1.11-58.43-1-84.31c-5.23-65.5,8.28-77.75-2.62-92.93Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,245.5c4,17.55.81,45.19-1.38,57.36-2.32-18.48-3.49-42.43-4.07-60C332.68,239.52,334.64,239.3,336.06,245.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.68 396.58 360.23 396.58 360.99 391.48 345.6 390.96 345.68 396.58",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,170c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63C350.31,188.12,346.9,175.87,349.83,170Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.83,170c1.37-2.72,8.73-4.43,12.75-4.42l3,13.36s-8,11.89-11.34,10.63C350.31,188.12,346.9,175.87,349.83,170Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,393.31a.19.19,0,0,0,0-.19.2.2,0,0,0-.21-.11c-.42.07-4.12.65-4.62,1.71a.65.65,0,0,0,0,.63,1.1,1.1,0,0,0,.86.57c1.21.12,3-1.56,3.9-2.58Zm-4.44,1.54c.34-.56,2.26-1.08,3.72-1.35-1.32,1.34-2.48,2.09-3.16,2a.71.71,0,0,1-.56-.38.25.25,0,0,1,0-.25S336.9,394.86,336.91,394.85Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.35,393.31a.05.05,0,0,0,0,0,.19.19,0,0,0,0-.19c-.06-.07-1.54-1.78-2.91-1.87a1.44,1.44,0,0,0-1.09.37c-.41.37-.37.69-.27.89.43.86,3.09,1.16,4.16.93A.18.18,0,0,0,341.35,393.31Zm-3.91-1.26a.79.79,0,0,1,.16-.18,1,1,0,0,1,.79-.27,4.6,4.6,0,0,1,2.39,1.47c-1.19.1-3.11-.26-3.37-.78A.24.24,0,0,1,337.44,392.05Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.08 389.76 342.42 393.17 339.01 386.06 334.55 376.76 334.02 375.68 341.68 372.27 342.27 373.49 346.59 382.5 350.08 389.76",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.59 382.5 339.01 386.06 334.55 376.76 342.27 373.49 346.59 382.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,219.12S296.6,280,303.23,308.6c6,25.89,32.5,74.92,32.5,74.92L346,378.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,219.12S296.6,280,303.23,308.6c6,25.89,32.5,74.92,32.5,74.92L346,378.38s-16.39-59.19-18.16-72.05c-3.46-25,18.77-60.33,18.77-87.21Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.06,392.1l7.6-5.53a.66.66,0,0,1,.88.06l5.25,5.39a1.35,1.35,0,0,1-.21,2c-2.69,1.88-4.08,2.66-7.42,5.09-2.06,1.5-6.16,4.81-9,6.88s-5-.63-4-1.74c4.48-5,5.42-8.1,6.12-10.91A2.17,2.17,0,0,1,341.06,392.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.07 385.69 348.3 379.64 346.61 374.25 332.44 380.71 335.07 385.69",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,169.36c-1.09-2.84-10.65-6-15.45-7L310,178.08s7.84,11.26,11.27,10.33C325.33,187.31,329.92,175.45,327.56,169.36Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,169.36c-1.09-2.84-10.65-6-15.45-7L310,178.08s7.84,11.26,11.27,10.33C325.33,187.31,329.92,175.45,327.56,169.36Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.07,168.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.28,100.28,0,0,0-14.45-1.9,107.4,107.4,0,0,0-15.44,0C324.59,167,317.07,168.57,317.07,168.57Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.07,168.57s-4,1.4,4,50.55h34c-.57-13.84-.59-22.38,6-50.8a100.28,100.28,0,0,0-14.45-1.9,107.4,107.4,0,0,0-15.44,0C324.59,167,317.07,168.57,317.07,168.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.6,217.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355A.61.61,0,0,1,355.6,217.13Z",
    style: {
      fill: "#3B5EEB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.6,217.13l1.53,3c.12.24-.16.48-.55.48H320.9c-.31,0-.56-.15-.58-.35l-.31-3c0-.21.25-.39.58-.39H355A.61.61,0,0,1,355.6,217.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,221h.92c.19,0,.33-.1.31-.21l-.43-4c0-.12-.17-.21-.35-.21h-.93c-.18,0-.32.09-.31.21l.43,4C350.63,220.88,350.79,221,351,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.61,221h.92c.18,0,.32-.1.31-.21l-.43-4c0-.12-.17-.21-.36-.21h-.92c-.19,0-.32.09-.31.21l.43,4C328.26,220.88,328.42,221,328.61,221Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.6afacaaba4b886bebafa9db303eb8152.svg";
export { ForwardRef as ReactComponent };